import { FC } from 'react'
import { useParams } from 'react-router-dom'
import { ReactComponent as CloseIcon } from 'src/assets/svg/modal-close.svg'
import { useGetReviewAnalysisSpikeBreakdownQuery } from 'src/reactQuery/useGetReviewAnalysisSpikeBreakdownQuery'
import { useReviewAnalysisDateRange } from 'src/hooks/useReviewAnalysisDateRange'
import { SpikeBreakdownItem } from 'src/services/reviewAnalysisApi/interfaces/reviewAnalysis.interface'
import styles from './spikeBreakdownModal.module.scss'
import { getPlatformIcon } from '../platformIcons'

interface Props {
  isOpen: boolean
  onClose: () => void
  platforms?: SpikeBreakdownItem[]
  spikeDate?: string
}

export const SpikeBreakdownModal: FC<Props> = ({
  isOpen,
  onClose,
  platforms,
  spikeDate,
}) => {
  const { campaignId = '' } = useParams<{ campaignId: string }>()
  const dateRange = useReviewAnalysisDateRange()
  const { data } = useGetReviewAnalysisSpikeBreakdownQuery(
    campaignId,
    spikeDate,
    dateRange
  )

  if (!isOpen) return null

  const resolvedPlatforms = platforms ?? data?.platforms ?? []
  const resolvedDate = spikeDate ?? data?.spikeDate ?? ''

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) onClose()
  }

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.modal}>
        {/* Header */}
        <div className={styles.header}>
          <div>
            <h2 className={styles.title}>Spike Breakdown</h2>
            <p className={styles.spikeDate}>{resolvedDate}</p>
          </div>
          <button className={styles.closeBtn} onClick={onClose} type="button">
            <CloseIcon />
          </button>
        </div>

        {/* Platform breakdown list */}
        <div className={styles.platformList}>
          {resolvedPlatforms.map((platform) => {
            const Icon = getPlatformIcon(platform.platform)
            return (
              <div className={styles.platformRow} key={platform.name}>
                <span className={styles.platformIcon}>
                  <Icon />
                </span>
                <span className={styles.platformName}>{platform.name}</span>
                <span className={styles.platformChange}>
                  {platform.change > 0
                    ? `+ ${platform.change}%`
                    : `- ${Math.abs(platform.change)}%`}
                </span>
              </div>
            )
          })}
        </div>

        {/* Footer */}
        <div className={styles.footer}>
          <button className={styles.doneBtn} onClick={onClose} type="button">
            Done
          </button>
        </div>
      </div>
    </div>
  )
}
